export default "__VITE_ASSET__09710f0a__"